import { HTMLAttributes } from "react";

interface BlogIconProps extends HTMLAttributes<SVGElement> {}

const BlogIcon = ({ ...props }: BlogIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.40002 3.20001C2.40002 2.09545 3.29546 1.20001 4.40002 1.20001H19.6C20.7046 1.20001 21.6 2.09544 21.6 3.20001V20.8C21.6 21.9046 20.7046 22.8 19.6 22.8H4.40002C3.29545 22.8 2.40002 21.9046 2.40002 20.8V3.20001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8 12L7.20005 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.8 7.20001L7.20005 7.20001"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 16.8H7.2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BlogIcon;
